module.exports = __webpack_public_path__ + "static/img/itom_top.8486b987.svg";